import React, { memo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getItem } from 'src/components/utilities/utils';

const useAuth = () => {
  const _token = getItem('token');
  const _role = getItem('role');

  if (_token) {
    return {
      auth: true,
      role: _role
    };
  } else {
    return {
      auth: false,
      role: null
    };
  }
};

//protected Route state
type ProtectedRouteType = {
  roleRequired?: 'Admin' | 'Employee';
};

const ProtectedRoutes = (props: ProtectedRouteType) => {
  const { auth, role } = useAuth();
  const location = useLocation();
  const prevLocation = location.pathname;

  const localData = localStorage.getItem('userData');
  const userData = localData && JSON.parse(localData);

  // Restrict "Studio Guest" from all except live-event videos
  if (userData?.role.includes('Studio Guest') && !prevLocation.includes('/videos/live-event')) {
    return <Navigate to="/unAuthorized" replace />;
  }

  // Restrict "Video Creator" from accessing /users/user-listing
  if (userData?.role === 'Video Creator' && prevLocation === '/users/user-listing') {
    return <Navigate to="/unAuthorized" replace />;
  }

  // Restriction for role "User"
  if (userData?.role === 'User') {
    const allowedPaths = [
      '/channels',
      '/add-video/0',
      '/add-resource',
      '/addlivestream',
      '/upload-video'
    ];

    const dynamicAllowedPaths = [
      /^\/channels\/[^/]+$/, // matches /channels/:id
      /^\/videos\/[^/]+$/, // matches /videos/:id
      /^\/videos\/live-event\/[^/]+$/ // matches /videos/live-event/:id
    ];

    const isAllowed =
      allowedPaths.includes(prevLocation) ||
      dynamicAllowedPaths.some((pattern) => pattern.test(prevLocation));

    if (!isAllowed) {
      return <Navigate to="/unAuthorized" replace />;
    }
  }

  if (props.roleRequired) {
    return auth ? (
      props.roleRequired === role ? (
        <Outlet />
      ) : (
        <Navigate to="/login" />
      )
    ) : (
      <Navigate to="/login" />
    );
  } else {
    return auth ? <Outlet /> : <Navigate to={`/login?returnUrl=${prevLocation}`} />;
  }
};

export default memo(ProtectedRoutes);
